
// index featured products
function ProductSlider() {
  const $slider = $('.featured_products');
  const totalSlides = $slider.children().length;

  const slidesToShow = 4;

  if (totalSlides <= slidesToShow) {
    $('.prev-arrow, .next-arrow').hide(); // hide arrows
  }

  $slider.slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: slidesToShow,
    prevArrow: $('.prev-arrow'),
    nextArrow: $('.next-arrow'),
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
}



ProductSlider();



// product tab
$(".cmn-tab").click(function () {
        $(this).addClass("active").siblings().removeClass("active");

        let tabId = $(this).attr("data-id");

        $(this).closest(".titl-tab-wrap").next(".tab-content-wrapper").children().each(function () {
            let TabcontId = $(this).attr("data-id");
            if (tabId === TabcontId) {
                $(this).show().addClass("active").siblings().hide().removeClass("active");
            }
        });

    });




// collection page filter show more
function ShowMore() {
    let showMoreBtn = document.getElementById("showMoreBtn");

    if (showMoreBtn) {
        showMoreBtn.addEventListener("click", function () {
            document.querySelectorAll(".cus-filter-item").forEach(function (item) {
                item.style.display = "block";
            });
            this.style.display = "none"; // Hide the button after clicking
        });
    } else {
        // console.error("Error: #showMoreBtn not found.");
    }
}


ShowMore();




// // subscription price set
// quantity change
 $('.m-quantity__input').on('input change', function () {
    updateOneTimePrice();
    RewardPoint();
    NonsubscriptionPro();

  document.querySelectorAll('.appstle_subscription_wrapper_option input').forEach(input => {
   input.addEventListener('change', function(){
       updateOneTimePrice();
   });
});
 });

function updateOneTimePrice(){
   const purType = document.querySelector('.appstle_subscription_wrapper_option input:checked');
  if (purType != null){
  const Notsub = purType.value;

   setTimeout(() => {
       if(!Notsub){
           const oneTimePriceElement = document.querySelector('.appstle_one_time_details_wrapper .appstle_subscription_amount');
           const targetPriceElement = document.querySelector('.product-block-group--price .m-price__regular .m-price-item');

           if (oneTimePriceElement && targetPriceElement) {
             targetPriceElement.innerText = oneTimePriceElement.innerText;
           }
       }
   },1000);
  }
}

// Listen for variant changes and update Appstle price span (only if Appstle is loaded)
const checkAppstleLoaded = setInterval(() => {
  const appstleWrapper = document.querySelector('.appstle_subscription_wrapper');

  if (appstleWrapper && typeof MinimogEvents !== 'undefined' && typeof MinimogTheme !== 'undefined') {
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, (data) => {
      // Wait for Appstle to update its prices
      setTimeout(() => {
        // Update Appstle price modified span
        const appstlePriceSpan = document.querySelector('[data-appstle-price-modified]');
        const oneTimePriceElement = document.querySelector('.appstle_one_time_details_wrapper .appstle_subscription_amount');

        if (appstlePriceSpan && oneTimePriceElement) {
          appstlePriceSpan.textContent = oneTimePriceElement.textContent;
        }

        // Update other prices
        updateOneTimePrice();
        RewardPoint();
      }, 100);
    });

    clearInterval(checkAppstleLoaded);
  }
}, 500);

// Move Appstle benefits block to Appstle subscription wrapper (only if block exists)
if (document.querySelector('[data-appstle-benefits]')) {
  // Save original block reference
  let originalBenefitsBlock = document.querySelector('[data-appstle-benefits]');
  let benefitsBlockClone = null;

  const moveBenefitsBlock = () => {
    const appstleTarget = document.querySelector('.appstle_subscribe_option');

    // Check if our block is still in the DOM
    let benefitsBlock = document.querySelector('[data-appstle-benefits]');

    if (!benefitsBlock && benefitsBlockClone) {
      // Block was removed, use clone
      benefitsBlock = benefitsBlockClone.cloneNode(true);
      document.body.appendChild(benefitsBlock);
    }

    if (appstleTarget && benefitsBlock) {
      // Save clone before moving
      benefitsBlockClone = benefitsBlock.cloneNode(true);

      // Check if not already inside
      if (!appstleTarget.contains(benefitsBlock)) {
        appstleTarget.prepend(benefitsBlock);
        benefitsBlock.classList.remove('m:hidden');
      }
    }
  };

  // Initial move
  const moveAppstleBenefits = setInterval(() => {
    moveBenefitsBlock();
    const benefitsBlock = document.querySelector('[data-appstle-benefits]');
    const appstleTarget = document.querySelector('.appstle_subscribe_option');
    if (appstleTarget && benefitsBlock && appstleTarget.contains(benefitsBlock)) {
      clearInterval(moveAppstleBenefits);
    }
  }, 500);

  setTimeout(() => clearInterval(moveAppstleBenefits), 10000);

  // Re-move on variant change
  if (typeof MinimogEvents !== 'undefined' && typeof MinimogTheme !== 'undefined') {
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, () => {
      setTimeout(moveBenefitsBlock, 1200);
    });
  }
}




// reward point on the product page
function RewardPoint(){
 setTimeout(() => {
    const priceElement = document.querySelector('.product-block-group--price .m-price__regular .m-price-item');
    if (!priceElement) return;
    const StoreTotalPrice = priceElement.innerText;
    const matchedPrice = StoreTotalPrice.match(/[\d.]+/);
    let roundedPrice = 0;
    if (matchedPrice) {
      const price = parseFloat(matchedPrice[0]);
      roundedPrice = Math.ceil(price / 5) * 5;
    }

    const rewardPointElement = document.querySelector(".reward-point-wrap");
    if (rewardPointElement) {
      rewardPointElement.innerText = roundedPrice;
    }
}, 1000);
}



RewardPoint();


// input change for non subscription product
const regularPriceEl = document.querySelector('.only-non-subscription .product-block-group--price .m-price__regular .m-price-item');
const hiddenInput = document.querySelector(".only-non-subscription .fornonsubpro");

if (regularPriceEl && hiddenInput) {
  hiddenInput.value = regularPriceEl.innerText;
}

function NonsubscriptionPro(){
  const qtyElement = document.querySelector(".only-non-subscription .m-quantity__input");
  const priceElement = document.querySelector('.fornonsubpro');
  const targetElement = document.querySelector('.only-non-subscription .product-block-group--price .m-price__regular .m-price-item');

  if (!qtyElement || !priceElement || !targetElement) return;

  const QtyVal = qtyElement.value;
  const StoreTotalPrice = priceElement.value;
  const matchedPrice = StoreTotalPrice.match(/[\d.]+/);
  const singlePrice = matchedPrice ? parseFloat(matchedPrice[0]) : 0;

  // Calculate total price
  const totalPrice = QtyVal * singlePrice;
  const formattedPrice = `$${totalPrice.toFixed(2)}`;
  targetElement.innerText = formattedPrice;
}







// tab products on the index page
 $(".product-cmn-tab").click(function(){
      // tab menu active class add
       $(this).addClass("active");
       $(this).siblings().removeClass("active");

       // tab content active class add
       let tabId = $(this).attr("data-id");

        $(this).parent().parent().next().children().each(function(){
           let TabcontId = $(this).attr("data-id");
            if (tabId == TabcontId){
               $(this).show();
               $(this).addClass("active");
               $(this).siblings().hide();
               $(this).siblings().removeClass("active");
            }
        });
});




// index testimonials
function IndexTestimonialsSlider() {
  const $slider = $('.testimonials-slider');
  const totalSlides = $slider.children().length;

  const slidesToShow = 3;

  if (totalSlides <= slidesToShow) {
    $('.testiprev-arrow, .testinext-arrow').hide(); // hide arrows
  }

  $slider.slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: slidesToShow,
    prevArrow: $('.testiprev-arrow'),
    nextArrow: $('.testinext-arrow'),
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}



IndexTestimonialsSlider();




// index product tab
const slider = document.querySelector('.tab-mouse-scroll');
if (slider) {
  let isDown = false;
  let startX;
  let scrollLeft;

  slider.addEventListener('mousedown', (e) => {
    isDown = true;
    slider.classList.add('active');
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });
  slider.addEventListener('mouseleave', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  slider.addEventListener('mouseup', () => {
    isDown = false;
    slider.classList.remove('active');
  });
  slider.addEventListener('mousemove', (e) => {
    if(!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 3; //scroll-fast
    slider.scrollLeft = scrollLeft - walk;
    console.log(walk);
  });
}




// product page first time open
